import ConsultSection from "../PageElements/HomePageElements/ConsultSection";
import PaymentRefundPolicyMainSection from "../PageElements/PaymentRefundPolicyPageElements/PaymentRefundPolicyMainSection";



export default function PaymentRefundPolicy() {
    return (
        <>

           <PaymentRefundPolicyMainSection/>
            <ConsultSection/>
            
        </>
    )
}